import { atomWithStorage } from 'jotai/utils';

export type FontSize = 'default' | 'comfort';
export type Theme = 'dark' | 'light';

export const fontSizeAtom = atomWithStorage<FontSize>('opal-font-size', 'default');
export const themeAtom = atomWithStorage<Theme>('opal-theme', 'light');
